export const getPermission = (roleArr) => {
    const userObject = JSON.parse(localStorage.getItem('user') ?? '{}');
    const roles = userObject?.user?.roles ?? [];
    return roles.some((r) => roleArr.includes(r));
};
